var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "putQuestions" }, [
    _vm.questions && _vm.questions.length
      ? _c(
          "div",
          { staticClass: "showQuestion" },
          _vm._l(_vm.questions, function(item, index) {
            return _c(
              "div",
              {
                key: index + "_" + _vm.questions.length,
                staticClass: "putQuestionsItem"
              },
              [
                _c("div", { staticClass: "itemTool" }, [
                  _c(
                    "span",
                    { staticStyle: { "font-size": "10px", color: "#B6B6BB" } },
                    [_vm._v(_vm._s(item.createTime))]
                  ),
                  _vm._v(" "),
                  _vm.userType === "2"
                    ? _c("span", { staticClass: "rightTool" }, [
                        _c("span", {
                          staticClass: "toolStyle el-icon-edit-outline",
                          on: {
                            click: function($event) {
                              return _vm.editAsk(item)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "toolStyle el-icon-delete",
                          on: {
                            click: function($event) {
                              return _vm.deleteAsk(item)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "font-size": "13px"
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(item.isAnswer ? "已解答" : "未解答")
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-switch", {
                              attrs: {
                                "active-color": "#1890FF",
                                "active-value": 1,
                                "inactive-value": 0
                              },
                              on: {
                                change: function($event) {
                                  return _vm.updateAsk(item.content, item)
                                }
                              },
                              model: {
                                value: item.isAnswer,
                                callback: function($$v) {
                                  _vm.$set(item, "isAnswer", $$v)
                                },
                                expression: "item.isAnswer"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "itemToolLabel" }, [
                  _c(
                    "div",
                    { staticClass: "name_left" },
                    [
                      _c(
                        "el-breadcrumb",
                        { attrs: { separator: "/" } },
                        [
                          _c(
                            "el-breadcrumb-item",
                            { attrs: { title: item.catalogName } },
                            [_vm._v(_vm._s(item.catalogName))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-breadcrumb-item",
                            { attrs: { title: item.resourceName } },
                            [_vm._v(_vm._s(item.resourceName))]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      item.pageLocation
                        ? _c("span", { staticClass: "askLabel" }, [
                            _vm._v(_vm._s(item.pageLocation))
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  (_vm.userType === "2" || _vm.userType === "3") &&
                  item.isAnswer === 1
                    ? _c(
                        "span",
                        {
                          staticClass: "writeDown",
                          on: {
                            click: function($event) {
                              return _vm.editStatus(item, "addRecord")
                            }
                          }
                        },
                        [_vm._v("记一笔")]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("p", {
                  staticClass: "editorShowArea",
                  attrs: { title: item.content },
                  domProps: { innerHTML: _vm._s(item.content) }
                }),
                _vm._v(" "),
                _vm.userType === "2" || _vm.userType === "3"
                  ? _c(
                      "div",
                      [
                        item.addRecord
                          ? _c("el-input", {
                              attrs: {
                                height: "100px",
                                type: "textarea",
                                placeholder: "请输入内容(失焦时自动保存)",
                                maxlength: "150",
                                resize: "none"
                              },
                              on: {
                                blur: function($event) {
                                  return _vm.editorBlur(
                                    _vm.askRecord,
                                    item,
                                    "askRecord"
                                  )
                                }
                              },
                              model: {
                                value: _vm.askRecord,
                                callback: function($$v) {
                                  _vm.askRecord = $$v
                                },
                                expression: "askRecord"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(item.askRecordList, function(record, rindex) {
                          return _c(
                            "div",
                            {
                              key: rindex + "record",
                              staticClass: "recordStyle"
                            },
                            [
                              record.editorRecord
                                ? _c("el-input", {
                                    attrs: {
                                      height: "100px",
                                      type: "textarea",
                                      placeholder: "请输入内容(失焦时自动保存)",
                                      maxlength: "150",
                                      resize: "none"
                                    },
                                    on: {
                                      blur: function($event) {
                                        return _vm.editorBlur(
                                          record.content,
                                          item,
                                          "editorRecord",
                                          rindex
                                        )
                                      }
                                    },
                                    model: {
                                      value: record.content,
                                      callback: function($$v) {
                                        _vm.$set(record, "content", $$v)
                                      },
                                      expression: "record.content"
                                    }
                                  })
                                : _c(
                                    "el-tooltip",
                                    { attrs: { placement: "top" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { cursor: "pointer" },
                                          attrs: { slot: "content" },
                                          on: {
                                            click: function($event) {
                                              return _vm.editStatus(
                                                record,
                                                "editorRecord"
                                              )
                                            }
                                          },
                                          slot: "content"
                                        },
                                        [_vm._v("编辑")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "editorShowArea",
                                        domProps: {
                                          innerHTML: _vm._s(record.content)
                                        }
                                      })
                                    ]
                                  ),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "el-icon-close",
                                on: {
                                  click: function($event) {
                                    return _vm.deleteAskRecord(record)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ]
            )
          }),
          0
        )
      : _vm.userType === "2"
      ? _c(
          "div",
          { staticClass: "isEmpty" },
          [
            _c("el-empty", { attrs: { "image-size": 100, description: " " } }, [
              _c("p", [_vm._v("可以去发起提问哦")]),
              _vm._v(" "),
              _c("p", [_vm._v("学习就是不断发现问题再解决的过程")])
            ])
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.userType == 2 || _vm.userType == 3
      ? _c(
          "div",
          { staticClass: "setQuestion" },
          [
            _c("el-input", {
              attrs: {
                type: "textarea",
                placeholder: "请输入问题",
                maxlength: "150",
                resize: "none"
              },
              model: {
                value: _vm.questionContent,
                callback: function($$v) {
                  _vm.questionContent = $$v
                },
                expression: "questionContent"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bottombtn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.addQuestion()
                      }
                    }
                  },
                  [_vm._v("提交")]
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a08748d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a08748d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/IT/components/putQuestions.vue
// module id = null
// module chunks = 